var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrdered = function SvgOrdered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H2v2h12v-2Zm0-4H2v2h12V6Zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4ZM2 16h8v-2H2v2Z"
  })));
};
export default SvgOrdered;